import { spacing } from '@akin-home/theme';
import React from 'react';
import { Text, View } from 'react-native';
import { RobotAvatarBadge } from '../../components/RobotAvatarBadge';
import { RobotDevice } from '../../types';
import { getRobotTypeDisplayName } from '../../utils';
import { ConnectToRobotButton } from './ConnectToRobotButton';

type ConnectToRobotComponentProps = {
  robotDevice?: RobotDevice;
};

const itemDiameter = 440;

export const ConnectToRobotComponent = ({
  robotDevice,
}: ConnectToRobotComponentProps) => {
  const robotDeviceTypeDisplayName = getRobotTypeDisplayName(robotDevice?.type);

  return (
    <View
      style={{
        flex: 1,
        marginHorizontal: spacing[0],
        borderRadius: 10,
        paddingVertical: spacing[3],
        paddingHorizontal: spacing[3],
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <RobotAvatarBadge
        robotDevice={robotDevice}
        size={itemDiameter - spacing[4] * 2}
      />

      <Text
        style={{
          fontSize: 35,
          color: 'black',
          marginTop: spacing[2],
          marginHorizontal: spacing[1],
          textAlign: 'center',
          fontWeight: 'bold',
          textTransform: 'capitalize',
        }}
        adjustsFontSizeToFit
        numberOfLines={1}
      >
        {robotDevice?.name ?? ''}
      </Text>
      <Text
        style={{
          fontSize: 16,
          color: 'black',
          marginHorizontal: spacing[1],
          textAlign: 'center',
          fontStyle: 'italic',
        }}
        adjustsFontSizeToFit
        numberOfLines={1}
      >
        {robotDeviceTypeDisplayName
          ? `(Model: ${robotDeviceTypeDisplayName})`
          : ''}
      </Text>

      <View
        style={{
          flex: 1,
          width: '100%',
          marginTop: spacing[3],
          justifyContent: 'flex-end',
        }}
      >
        <ConnectToRobotButton robotDevice={robotDevice} />
      </View>
    </View>
  );
};
